module.exports = "/_next/static/images/b3447a6bb9d5b1a5af30f38e21f3ad4b-boy-looking-to-the-front-lg@3x.jpg";